import { InputLabel, MenuItem, Select, FormControl } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  value: string;
  label: string;
  onChange: (value: string) => void;
  items: { key: string; label: string }[];
}

const SettingsDropdown = ({ value, items, label, onChange }: IProps) => {
  const { t } = useTranslation();
  return (
    <FormControl>
      <InputLabel id={`${label}-select`}>{t(label)}</InputLabel>
      <Select
        labelId={`${label}-select`}
        id={`${label}-select`}
        value={value ?? ''}
        label={t(label)}
        onChange={(e) => onChange(e.target.value)}
      >
        {items?.map((item) => {
          return (
            <MenuItem key={item?.key} value={item?.key}>
              {t(item?.label)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SettingsDropdown;
